import Constants from "/js/core/constants.js";
import FocusUtil from '/js/util/focus-util.js';

/**
 * A "full size" view which is sometimes used in-between steps in interactions
 * that have multiple steps (`MultiItemInteractionViews`).
 *
 * <p>Looks a lot like the interaction result view, but isn't.
 */
export default class ResponseView {

  #$el;
  #$content;
  #$text;
  #data;
  
  constructor(data) {
    this.#data = data;
    
    const s = `
        <div class="response-view">
          <div class="response-content">
            <div class="text"></div>
            <div class="response-button interaction-big-button" tabindex="${Constants.TABINDEX_CONTENT_END - 1}">${ this.#data.nextText }</div>
          </div>
        </div>`;
    this.#$el = $(s);

    this.#$content= this.#$el.find(".response-content");
    this.#$text = this.#$el.find(".text");
    
    const $button = this.#$el.find(".response-button");
    $button.click(e => this.#onButton(e));
    FocusUtil.doStandardTreatment($button);
  }

  get $el() {
    return this.#$el;
  }

  get $content() {
    return this.#$content;
  }

  populate(isCorrect) {
    // Populate the right text.
    let text;
    if (this.#data.universal) {
      // If "universal" exists, always use it:
      text = this.#data.universal;
    } else if (this.#data.correct && this.#data.incorrect) {
      text = isCorrect ? this.#data.correct : this.#data.incorrect;
    } else {
      // Shouldn't happen
      text = ""; 
    }

    this.#$text.text(text);

    this.#$el.show();
  }

  #onButton(e) {
    this.#$el.trigger("response-view");
  }
}
